import { Controller } from "@hotwired/stimulus"

// LRPO-4110 — consolidated exhibitor 401-redirect handler.
//
// After an admin reverses a masquerade, background jQuery AJAX from the now
// stale exhibitor page 401s. This controller catches any jQuery AJAX 401 and
// sends the (now admin-scoped) session back to the admin dashboard, instead of
// leaving the page wedged on silent failures. It replaces the per-view inline
// copies of this logic that used to live in the dashboard
// ($(document).ajaxError + $.ajaxSetup) and door scanning reports (the
// DataTables `error:` callback) views.
//
// Mount with the redirect target:
//   data-controller="auth-check"
//   data-auth-check-redirect-value="<%= admin_dashboard_index_path %>"
//
// jQuery is global as window.$ (see app/frontend/packs/application.js). DataTables
// uses jQuery.ajax, so the single global ajaxError binding covers it too.
export default class extends Controller {
  static values = { redirect: String }

  connect() {
    // Store the bound reference so disconnect() can remove this exact handler.
    // Without the matching .off(), every Turbo Drive visit re-binds and a single
    // 401 would then fire the redirect once per leaked binding.
    this.boundAjaxError = this.handleAjaxError.bind(this)
    window.$(document).ajaxError(this.boundAjaxError)
  }

  disconnect() {
    if (this.boundAjaxError) {
      window.$(document).off("ajaxError", this.boundAjaxError)
      this.boundAjaxError = null
    }
  }

  // jQuery calls ajaxError handlers as (event, jqXHR, ajaxSettings, thrownError).
  handleAjaxError(_event, xhr) {
    if (xhr && xhr.status === 401) {
      window.location.href = this.redirectValue
    }
  }
}
